import { IACDLEvent } from '../../../services/eventBus.service';

export const WorkspaceDeletedEventType = Symbol('WORKSPACE_DELETED_EVENT');

export class WorkspaceDeletedEvent implements IACDLEvent {
  readonly type: symbol = WorkspaceDeletedEventType;
}
